import React from 'react';
import { Form } from 'react-bootstrap';
import { envConfig } from '../../../../utils/config';

export interface Option {
  label: string;
  value: string | number;
  disabled?: boolean;
}

interface CustomFormSelectProps {
  name?: string
  value: string | number;
  onChange: (e: React.ChangeEvent<HTMLSelectElement>) => void;
  options: Option[];
  disabled?: boolean;
  placeholder?: string;
  className?: string;
  onBlur?: () => void;
  autoFocus?: boolean
  size?: 'lg' | 'sm' | 'md'
}

const CustomFormSelect: React.FC<CustomFormSelectProps> = ({
  name,
  value,
  onChange,
  onBlur,
  options,
  disabled = false,
  size = envConfig.DEFAULT_INPUT_FIELD_SIZE,
  placeholder = 'Select an option',
  className = `form-select-${size}`,
  autoFocus = false
}) => {
  return (
    <Form.Select
      name={name}
      className={className}
      value={value}
      onChange={onChange}
      disabled={disabled}
      onBlur={onBlur}
      autoFocus={autoFocus}
    >
      <option value="">{placeholder}</option>
      {options.map((option) => (
        <option
          key={option.value}
          value={option.value}
          disabled={option.disabled}
        >
          {option.label}
        </option>
      ))}
    </Form.Select>
  );
};

export default CustomFormSelect;